<template>
  <!-- modal Password Edit-->
  <validation-observer ref="passwordForm" #default="{ handleSubmit }">
    <b-modal
      id="modal-reset-supplier-password"
      hide-footer
      ok-title="修改"
      cancel-title="關閉"
      cancel-variant="outline-secondary"
      centered
      :title="getTitle()"
      @ok="handleEdit"
      :ok-disabled="false"
    >
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-2" @submit.prevent="handleSubmit(handleEdit)" ref="resetPasswordForm">
          <div class="px-2">
            <validation-provider
              #default="{ errors }"
              name="密碼"
              vid="old_password"
              rules="required"
            >
              <b-form-group class="required" label="密碼：">
                <b-form-input
                  id="password"
                  type="password"
                  placeholder="輸入密碼"
                  v-model="supplierInfo.password"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              name="確認密碼"
              vid="password_confirmation"
              rules="required"
            >
              <b-form-group class="required" label="確認密碼：">
                <b-form-input
                  type="password"
                  v-model="supplierInfo.password_confirmation"
                  placeholder="輸入確認密碼"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="d-flex flex-wrap m-2 justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
              style="line-height: 1.1;"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hideModal"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </b-modal>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN.json';
localize('zh_cn',zh_CN)
import { required, email } from "@validations";
import { ref, onMounted } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import axiosIns from "@/libs/axios";
import {
  BModal,
  BButton,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BOverlay,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      loading: false,
    };
  },
  props: {
    supplierInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getTitle() {
      return "修改密碼";
    },
    resetForm() {
      this.supplierInfo = { passowrd: "", password_confirmation: "" };
    },
    hideModal() {
      this.$root.$emit("bv::hide::modal", "modal-reset-supplier-password", "#btnShow");
    },
    handleEdit() {
      this.loading = true;
      axiosIns
        .post("/supplier/resetPassword", this.supplierInfo)
        .then((response) => {
          this.loading = false;
          this.$bvModal.hide("modal-reset-supplier-password");
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          this.loading = false;
          const message = error.response.data.message;
          var showMessage = "";
          var showMessage = message;
          if (typeof showMessage === "object") {
            showMessage = "";
            for (var key in message) {
              if (message.hasOwnProperty(key)) {
                showMessage += message[key] + "\n";
              }
            }
          }
          this.$swal({
            text: showMessage,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
  },
};
</script>

<style></style>
